import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base = "group inline-flex items-center gap-3 rounded-full pl-6 pr-2 py-2 text-sm font-semibold transition-[background-color,color,transform,box-shadow] duration-300 active:scale-[0.97]";
const variants = {
  primary: "bg-[color:var(--ngp-teal)] text-[color:var(--ngp-ink)] hover:bg-white hover:shadow-[0_10px_40px_-10px_rgba(0,168,180,.7)]",
  dark: "bg-[color:var(--ngp-ink)] text-white hover:bg-[color:var(--ngp-teal)] hover:text-[color:var(--ngp-ink)]",
  ghost: "border border-white/40 text-white hover:bg-white hover:text-[color:var(--ngp-ink)]",
  outline: "border border-black/30 text-[color:var(--ngp-ink)] hover:bg-[color:var(--ngp-ink)] hover:text-white",
};
const dot = {
  primary: "bg-[color:var(--ngp-ink)] text-white",
  dark: "bg-[color:var(--ngp-teal)] text-[color:var(--ngp-ink)]",
  ghost: "bg-white/15 text-white group-hover:bg-[color:var(--ngp-ink)]",
  outline: "bg-[color:var(--ngp-ink)] text-white group-hover:bg-[color:var(--ngp-teal)] group-hover:text-[color:var(--ngp-ink)]",
};

export const CtaButton = ({ to, href, onClick, children, variant = "primary", testId, type, className = "", ...rest }) => {
  const inner = (
    <>
      <span>{children}</span>
      <span className={`grid h-9 w-9 place-items-center rounded-full transition-transform duration-500 group-hover:rotate-45 ${dot[variant]}`}>
        <ArrowUpRight size={16} aria-hidden="true" />
      </span>
    </>
  );
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testId} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testId} {...rest}>{inner}</a>;
  return <button type={type || "button"} onClick={onClick} className={cls} data-testid={testId} {...rest}>{inner}</button>;
};
